export default __webpack_public_path__ + "static/media/logoSm.ae950365.png";